import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { IDropdownSettings, NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { Subscription } from 'rxjs';
import { HandleError } from '../../../core/models/handle-error';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';

import { APP_SETTINGS } from '@services';
import { BMWListData } from '../../../core/models/bmwListData';
import { MINIListData } from '../../../core/models/miniListData';
import { MOTORRADListData } from '../../../core/models/motorradListData';
import { ResultStatus } from '../../../core/models/resultStatus';
import { ScopePatternFilterRequest } from '../../../core/models/scopePatternFilterRequest';
import { ScopePatternParamsRefDataResponse } from '../../../core/models/scopePatternParamsRefDataResponse';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { ModelMapService } from '../../model-map/model-map.service';
import { ScopePatternService } from '../scope-pattern.service';
import { NgIf, NgClass, NgFor } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NoiseCatalogShareContentComponent } from '../../noise-catalog-share-content/noise-catalog-share-content.component';
import { SearchFilterPipe } from '../../../shared/pipes/search-filter.pipe';
import { LoadMoreItemsPipe } from '../../../shared/pipes/load-more-items.pipe';

@Component({
    selector: 'app-scope-pattern-home',
    templateUrl: './scope-pattern-home.component.html',
    styleUrls: ['./scope-pattern-home.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        NgIf,
        FormsModule,
        NgMultiSelectDropDownModule,
        NgClass,
        NgFor,
        NoiseCatalogShareContentComponent,
        SearchFilterPipe,
        LoadMoreItemsPipe,
    ],
})
export class ScopePatternHomeComponent implements OnInit, OnDestroy {

  public newNoisecatalog: any;
  public screenWidth: any;
  private subscription: Subscription[] = [];
  public noisecatalogshareContentObject = {};
  public serviceError = 'Loading data. Please wait...';
  public dateFormat: string;
  APP_SETTINGS : any;
  public searchClick: boolean;

  // public large_bmw_image = "assets/images/C100_200px_BMW_RGB72DPI.png";
  public large_bmw_width = "150px";
  public large_bmw_height = "150px";
  public videoThumbnail =  APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail :  APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;


  username: string;
  public moreItems = 24;

  constructor(
    private utilityService: UtilityService,
    private spinnerService: SpinnerService,
    private noisecatalogService: ScopePatternService,
    private authService: AuthService,
    private analyticsService: AnalyticsService,
    private modelMapService: ModelMapService,
    private changeDetector: ChangeDetectorRef
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  dropdownESeriesList = [];
  dropdownAreaList = [];
  dropdownComponentList = [];
  dropdownDrivingConditionList = [];
  dropdownKindOfNoiseList = [];
  dropdownWeatherConditionList = [];
  selectedItems = [];
  BMW?: BMWListData;
  MINI?: MINIListData;
  MOTORRAD?: MOTORRADListData;
  prevMake?: string;
  currentMake?: string;
  makeSelected?: string;

  public areaList: any[];
  public areaFilterList: string[];
  public scopePatternParamsRefDataResponse: ScopePatternParamsRefDataResponse;

  public sproadicPermanentList = [];

  public seriesList: any[];
  public seriesFilterList: any[];

  public inputSeries = '';
  public inputModel = '';
  public inputEngine = '';

  public inputArea = '';
  public inputChannel: any;
  public channelsList = [];


  dropdownSettingsSeries: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'seriesName',
    itemsShowLimit: 25,
    limitSelection: 25,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };

  dropdownSettingsArea: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'signalName',
    itemsShowLimit: 25,
    limitSelection: 25,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false
  };
  
  dropdownSettings: IDropdownSettings = {
    singleSelection: false,
    itemsShowLimit: 25,
    limitSelection: 25,
    allowSearchFilter: true,
    enableCheckAll: false,
    clearSearchFilter: true,
    noDataAvailablePlaceholderText: 'No data available',
    searchPlaceholderText: 'Search',
    closeDropDownOnSelection: true,
    showSelectedItemsAtTop: false,
    defaultOpen: false,
  };


  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    if(APP_SETTINGS.isBMW === "true")
      this.makeSelected = "BMW";
    if(APP_SETTINGS.isMINI === "true")
      this.makeSelected = "MINI";
    this.searchClick = false;
    this.areaList = [];
    // set image details here. hopefully improves performance
    this.subscription = [];
    this.username = this.authService.getUserName();
    APP_SETTINGS.currentPage = 'videos';
    this.dateFormat = 'yyyy-MM-dd';

    this.subscription.push(this.modelMapService.getAllSeries().subscribe(data => {
      this.seriesList = data;
      this.dropdownESeriesList = this.seriesList;
      this.changeDetector.detectChanges();
    }));

    this.subscription.push(this.noisecatalogService.getAllSignals().subscribe(data => {
      this.areaList = data;
      this.dropdownAreaList = this.areaList;
      this.changeDetector.detectChanges();
    }));

    this.subscription.push(this.noisecatalogService.findAllScopePatternParamsRefData(this.makeSelected).subscribe(
      (data: ScopePatternParamsRefDataResponse) => {
        this.spinnerService.hide('bmwSpinner');
        this.scopePatternParamsRefDataResponse = data;
        this.changeDetector.detectChanges();
      },
      (err: ResultStatus) => {
        console.error('Error retrieving all ScopePattern params data', err);
      },
      () => this.populateNoiseParamList()
    ));

  }

  prePopulateFilteredScopePatternList() {

    if (sessionStorage.getItem('scopePatternFilterRequest')) {
      // this.spinnerService.show('bmwSpinner');
      this.searchClick = false;
      let scopePatternFilterRequest = JSON.parse(sessionStorage.getItem('scopePatternFilterRequest'));
      this.areaFilterList = scopePatternFilterRequest.areaFilterList;

      if (scopePatternFilterRequest.mainGroup === undefined
        && (scopePatternFilterRequest.seriesFilterList === undefined || scopePatternFilterRequest.seriesFilterList.length === 0)
        && (scopePatternFilterRequest.areaFilterList === undefined || scopePatternFilterRequest.areaFilterList.length === 0))
        {
        this.spinnerService.show('bmwSpinner');
        this.subscription.push(this.noisecatalogService.findAllScopePatternParamsRefData(this.makeSelected).subscribe(
          (data: ScopePatternParamsRefDataResponse) => {
            this.spinnerService.hide('bmwSpinner');
            this.scopePatternParamsRefDataResponse = data;
            this.changeDetector.markForCheck();
          },
          (err: ResultStatus) => {
            console.error('Error retrieving all ScopePattern params data', err);
            this.changeDetector.markForCheck();
          },
          () => this.populateNoiseParamList()
        ));
      }
      else {
        this.spinnerService.show('bmwSpinner');
        this.subscription.push(this.noisecatalogService.getScopePatternDataByFilter(scopePatternFilterRequest, this.makeSelected).subscribe(value => {
          this.spinnerService.hide('bmwSpinner');
          this.newNoisecatalog = value.scopePatternResourceList;
          this.changeDetector.markForCheck();
          //sessionStorage.setItem('scopePatternFilterRequest', JSON.stringify(scopePatternFilterRequest));
        },
          error => {
            this.spinnerService.hide('bmwSpinner');
            this.serviceError = HandleError.handleAPIError(error);
            this.changeDetector.markForCheck();
          }
        ));

      }
    }
    else
    {
      this.spinnerService.show('bmwSpinner');        
      this.subscription.push(this.noisecatalogService.findAllScopePatternParamsRefData(this.makeSelected).subscribe(
        (data: any) => {
          this.spinnerService.hide('bmwSpinner');
          this.newNoisecatalog = data.scopePatternResourceList;
          this.changeDetector.markForCheck();
        },
        (err: ResultStatus) => {
          console.error('Error retrieving all ScopePattern params data', err);
          this.changeDetector.markForCheck();
        },
      ));
    }
  }

  populateFilteredScopePatternList() {

    this.spinnerService.show('bmwSpinner');
    this.searchClick = true;
    let scopePatternFilterRequest = new ScopePatternFilterRequest();
    if (!((this.inputChannel === null || this.inputChannel === undefined || this.inputChannel === 'undefined'))) {
      scopePatternFilterRequest.mainGroup = this.inputChannel.mainGroupName;
    }    
    if (!((this.areaFilterList === null || this.areaFilterList === undefined))) {      
      const selectedSignals = filterAreasArray(this.areaList, this.areaFilterList);
      scopePatternFilterRequest.signalsFilterList = selectedSignals.filter(Boolean);
    }
    if (!((this.seriesFilterList === null || this.seriesFilterList === undefined))) {
      const selectedSeries = filterSeriesArray(this.seriesList, this.seriesFilterList);
      scopePatternFilterRequest.seriesFilterList = selectedSeries.filter(Boolean);
    }
    
    if ((scopePatternFilterRequest.seriesFilterList === undefined || scopePatternFilterRequest.seriesFilterList.length === 0)
      && (scopePatternFilterRequest.signalsFilterList === undefined || scopePatternFilterRequest.signalsFilterList.length === 0)) 
    {
      this.subscription.push(this.noisecatalogService.findAllScopePatternParamsRefData(this.makeSelected).subscribe(
        (data: any) => {
          this.spinnerService.hide('bmwSpinner');
          this.newNoisecatalog = data.scopePatternResourceList;
          this.changeDetector.markForCheck();
        },
        (err: ResultStatus) => {
          console.error('Error retrieving all ScopePattern params data', err);
          this.changeDetector.markForCheck();
        },
      ));
    }
    else {
      this.spinnerService.show('bmwSpinner');
      this.subscription.push(this.noisecatalogService.getScopePatternDataByFilter(scopePatternFilterRequest, this.makeSelected).subscribe(value => {
        this.spinnerService.hide('bmwSpinner');
        this.newNoisecatalog = value;
        this.changeDetector.markForCheck();
        //sessionStorage.setItem('scopePatternFilterRequest', JSON.stringify(scopePatternFilterRequest));

      },
        error => {
          this.spinnerService.hide('bmwSpinner');
          this.serviceError = HandleError.handleAPIError(error);
          this.changeDetector.markForCheck();
        }
      ));
    }

  }

  populateNoiseParamList() {

    if (this.scopePatternParamsRefDataResponse != null && this.scopePatternParamsRefDataResponse.status.statusCode === 'SUCCESS') {
      this.populateNoiseParamListByMake(this.makeSelected);
    }
  }

  populateNoiseParamListByMake(makeNameCurrent) {
    if (makeNameCurrent === 'BMW') {
      
    }
    else if (makeNameCurrent === 'MINI') {

    }
    else if (makeNameCurrent === 'MOTORRAD') {

    }
    this.prePopulateFilteredScopePatternList();
  }

  addScopePatternToWatchlist(scopePatternDisplayNumber) {
    //Analytics call
    this.analyticsService.trackSavedContentByTypeLineMake('Noise Catalog', scopePatternDisplayNumber, 'saved');
   
  }

  noisecatalogshareContent(scopePatternId, type, mainGroup, scopePatternDisplayNumber) {
    this.noisecatalogshareContentObject = {
      scopePatternId: scopePatternId,
      type: type,
      mainGroup: mainGroup,
      scopePatternDisplayNumber: scopePatternDisplayNumber
    };
  }
  ngOnDestroy(): void {
    this.subscription.map(s => s.unsubscribe());
  }

  screenRotate() {
    this.screenWidth = this.utilityService.getScreenWidth();
  }
  removeFromNoiseSelection(listType: any, listItem: any) {
    switch (listType) {

      case 'series':
        this.seriesFilterList = this.seriesFilterList.filter(item => item !== listItem.seriesName);
        break;
      case 'area':
        this.areaFilterList = this.areaFilterList.filter(item => item !== listItem.viewValue);
        break;
   
    }
  }


  addToNoiseSelection(listType: any, listItem: any) {
   
    if (listItem) {
      switch (listType) {
        case 'series':
          this.seriesFilterList.push(listItem.seriesName);
          break;
        case 'area':
          this.areaFilterList.push(listItem.viewValue);
          break;
      }
    }
  }

}

function filterSeriesArray(array, filter) {
  var myArrayFiltered = [];
  for (var i = 0; i < array.length; i++) {
    for (var j = 0; j < filter.length; j++) {
      if (array[i].id === filter[j].id && array[i].seriesName === filter[j].seriesName) {
        myArrayFiltered.push(array[i].seriesName);
      }
    }
  }
  return myArrayFiltered;
}

function filterAreasArray(array, filter) {
  var myArrayFiltered = [];
  for (var i = 0; i < array.length; i++) {
    for (var j = 0; j < filter.length; j++) {
      if(filter[j] === undefined)        
        continue;
      if (array[i].id === filter[j].id && array[i].signalName === filter[j].signalName) {
        myArrayFiltered.push(array[i].signalName);
      }
    }
  }
  return myArrayFiltered;
}

